{
  "title": "User Profile Overview",
  "title_Agrifirm": "User Profile",
  "title_Agravis": "Avidata Profile",
  "message": "Hello world, your User Profile Overview application is working!",
  "exampleModule": "Example module",
  "home": "Home",
  "profile": "Authentication Profile",
  "information": "Information",
  "search": "Search by email, firstname or lastname",
  "search_profile": "Search by full email address and press ENTER",
  "licenses": "Roles & Licenses",
  "not_found": "The Profile is not found",
  "basic_information": "Basic Information",
  "user_preferences": "User Preferences",
  "developer_tools": "Developer Tools",
  "labresults": "Lab results",
  "labResults_searchLabResults": "Search labresults by: labresult Id, silage description, Eurofins- or Ubn Id",
  "labResults_searchLabResultsButton": "Search labresults",
  "labResults_labResultId": "Labresult Id",
  "labResults_description": "Description",
  "labResults_labId": "Lab Id",
  "labResults_updated": "Processing date",
  "labResults_statusDescription": "Status",
  "labResults_reason": "Reason",
  "ToBeProcessed": "To be processed",
  "NotValidForProcessing": "Not valid for processing",
  "ReadyForProcessing": "Ready for processing",
  "Processing": "Processing",
  "Processed": "Processed",
  "ProcessingFailed": "Processing failed",
  "labResults_searchNotFound": "Could not find any.",
  "labResults_searchError": "Labresults could not be loaded.",
  "app_wizard": "Dev App Wizard",
  "business_partner": "Business partner (Not for Use)",
  "businessPartnerBackoffice": "Businesspartners",
  "businessPartnerBackoffice_searchBusinessPartners": "Search customers and or locations by: Name and address details, UBN, BRS, Eurofins or by KAT",
  "businessPartnerBackoffice_searchBusinessPartnersButton": "Search results",
  "businessPartnerBackoffice_id": "Id",
  "businessPartnerBackoffice_type": "Type",
  "businessPartnerBackoffice_name": "Name",
  "businessPartnerBackoffice_street": "Street",
  "businessPartnerBackoffice_postalCode": "Postalcode",
  "businessPartnerBackoffice_ubn": "Ubn",
  "businessPartnerBackoffice_brs": "Brs",
  "businessPartnerBackoffice_oneSap": "OneSap",
  "businessPartnerBackoffice_sapLegacyFeedId": "SapFeedId",
  "businessPartnerBackoffice_sapLegacyPlantId": "SapPlantId",
  "businessPartnerBackoffice_eurofins": "Eurofins",
  "businessPartnerBackoffice_kat": "Kat",
  "businessPartnerBackoffice_searchNotFound": "Could not find any.",
  "businessPartnerBackoffice_searchError": "BusinessPartner could not be loaded",
  "jwt_token": "JWT Token",
  "dev_api_tool": "Dev API Tool",
  "wizard_application": "Application",
  "wizard_applicationDescription": "Application Description",
  "wizard_applicationGroup": "Application Group",
  "wizard_applicationGroupName": "Application Group Name",
  "wizard_applicationGroups": "Application Groups",
  "wizard_applicationGroupTitled": "Application Group Titled:",
  "wizard_applicationName": "Application Name",
  "wizard_applicationRoles": "Application Roles",
  "wizard_applicationTitled": "Application Titled:",
  "wizard_back": "Back",
  "wizard_complete": "Complete",
  "wizard_createMessage": "You are about to create :",
  "wizard_deleteApplicationGroupSuccessMessage": "Your Application Group is now Successfully Deleted",
  "wizard_deleteApplicationSuccessMessage": "Your Application is now Successfully Deleted",
  "wizard_description": "Description",
  "wizard_next": "Next",
  "wizard_registrationApplicationGroupSuccessMessage": "Your Application Group is now Successfully Registered",
  "wizard_registrationSuccessMessage": "Your Application is now Successfully Registered",
  "wizard_reset": "Reset",
  "wizard_step1EnterApplicationGroupName": "Step1: Enter Application Group Name",
  "wizard_step1SelectApplication": "Step1: Select Application",
  "wizard_step1SelectApplicationGroup": "Step1: Select Application Group",
  "wizard_step2CreateApplicationName": "Step 2: Create Application Name",
  "wizard_step2DeleteApplication": "Step 2: Delete the Application",
  "wizard_step2DeleteApplicationGroup": "Step 2: Delete the Application Group",
  "wizard_step2RegisterApplicationGroup": "Step 2: Register the ApplicationGroup",
  "wizard_step3Complete": "Step 3: Complete",
  "wizard_step3EnterApplicationDescription": "Step 3: Enter Application Description",
  "wizard_step4SelectApplicationRole": "Step 4: Select Default Application Role",
  "wizard_step5SelectApplicationRole": "Step 5: Select a disallowed Profiletype",
  "wizard_step6RegisterApplication": "Step 6: Register the Application",
  "wizard_step7Complete": "Step 7: Complete",
  "wizard_theApplication": "The Application:",
  "wizard_underApplicationGroup": "Under the Application Group",
  "wizard_withDefaultRoleApplicationRoleName": "With the default Application RoleName",
  "wizard_withDisallowedRoleApplicationProfileType": "With a disallowed Profiletype",
  "wizard_youAreAboutToDelete": "You are about to delete:",
  "use_my_email": "My email"
}
